<template>
  <div class=" pd-0-f">
    <div style="background: #015197 !important;">
    <header id="header" class="navbar navbar-header container">
      <a id="mainMenuOpen" class="burger-menu " @click="mainMenuOpen">
        <feather type="menu"></feather>
        <div class="df-logo d-flex align-items-center">
          <img
            :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
            alt
            class="mg-l-10"
            style="max-width: 40px"
          />
          <span class="mg-l-5 ">{{
            $store.state.app.activeGroup.name | stripHtml
          }}</span>
        </div>
      </a>

      <div class="navbar-menu-wrapper">
        <div v-if="$store.state.app.isMobile" class="navbar-menu-header">
          <router-link
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: { id: $store.state.app.homePageId, cid: 0 }
            }"
            class="mg-r-10 df-logo"
          >
            <img
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              alt
              class
              style="max-width: 40px"
            />
            <span class="mg-l-5">{{
              $store.state.app.activeGroup.name | stripHtml
            }}</span>
          </router-link>
          <!-- <h1 style="font-size: 1.1rem" class="d-none d-xl-block">
            <router-link
              :to="({name: $store.state.app.activeGroup.publicPage.route, params: {id: $store.state.app.homePageId, cid: 0 } })"
              v-html="$store.state.app.activeGroup.name"
              class="df-logo logo tx-16"
              style="line-height: 1.1"
            ></router-link>
          </h1>-->
        </div>
        <div v-else class="navbar-brand">
          <router-link
            :to="{
              name: $store.state.app.activeGroup.publicPage.route,
              params: { id: $store.state.app.homePageId, cid: 0 }
            }"
            class="mg-r-10 d-flex"
          >
            <img
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              alt
              class="df-logo"
              style="max-width: 100px"
            />
            <img src="https://www.judcouncil.mn/2022/img/logo/logo-30jil.png" style="max-width: 100px" class="wd-mx-100 mg-l-20" />
          </router-link>
          <!-- <h1 style="font-size: 1.1rem" class="d-none d-xl-block">
            <router-link
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: { id: $store.state.app.homePageId, cid: 0 }
              }"
              v-html="$store.state.app.activeGroup.name"
              :class="`df-logo logo ${$store.state.app.activeGroup.id==9298?'tx-22-f':'tx-16'}`"
              style="line-height: 1.1"
            ></router-link>
          </h1> -->
        </div>

        <div class="order-2 mg-l-auto text-center pd-t-10">
          <h5 class="text-uppercase text-yellow  mg-b-0-f" style="color: #ffd900">Монгол улсын</h5>
          <h2 class="text-white text-uppercase mg-b-0-f">{{ $store.state.app.activeGroup.name }}</h2>
          <h5 class="text-uppercase text-yellow  mg-b-0-f" style="color: #ffd900">Цахим сургалтын систем</h5>
        </div>

        <div v-if="$store.state.app.isMobile" class="mg-x-10">
          <router-link
            :to="{ name: 'login' }"
            class="btn btn-outline-primary btn-block d-flex justify-content-center"
            type="button"
          >
            <feather type="log-in" class="mg-r-5" size="14"></feather>Нэвтрэх
          </router-link>
        </div>
        <div v-else class="navbar-right mg-l-50-f">
          <router-link
            :to="{ name: 'login' }"
            class="btn btn-primary text-white d-flex"
            ><feather type="log-in" class="mg-r-5" size="14"></feather
            >Нэвтрэх</router-link
          >
        </div>
      </div>
    </header>
  </div>

    <div id="subheader" class="ht-50 container pd-0-f">
      <div class="d-flex justify-content-between">
        <div></div>
        <ul
          id="navbarMenu"
          class="nav navbar-menu ht-50"
        >
          <li class="nav-label pd-l-20 pd-lg-l-25 d-lg-none">Үндсэн цэс</li>
          <li
            class="nav-item"
            v-for="(p, i) in pages"
            :key="i"
            :class="{ 'with-sub': getSub(p).length, show: activeId == p.id }"
          >
            <a
              v-if="getSub(p).length"
              @click="activeId = p.id"
              role="button"
              class="nav-link"
              :class="{ active: p.id == $route.params.id }"
              >{{ p.task }}</a
            >

            <router-link
              v-else-if="p.st1=='special'"
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: { id: p.id, cid: 0 }
              }"
              class="nav-link " style="color: white !important; background: #007a3e; border-radius: 3px; padding: 3px 5px;"
              :class="{ active: p.id == $route.params.id }"
              >{{ p.task }}</router-link
            >
            <router-link
              v-else
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: { id: p.id, cid: 0 }
              }"
              class="nav-link"
              :class="{ active: p.id == $route.params.id }"
              >{{ p.task }}</router-link
            >

            <ul v-if="getSub(p).length" class="navbar-menu-sub">
              <li class="nav-sub-item" v-for="(s, i) in getSub(p)" :key="i">
                <a
                  v-if="s.locTypeCode == 'link'"
                  class="nav-sub-link"
                  :href="s.taskEn"
                  target="_blank"
                >
                  <feather type="chevron-right"></feather>
                  {{ s.task }}
                </a>
                <router-link
                  v-else
                  class="nav-sub-link"
                  :to="{
                    name: $store.state.app.activeGroup.publicPage.route,
                    params: { id: s.id, cid: 0 }
                  }"
                >
                  <feather type="chevron-right"></feather>
                  {{ s.task }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
        <div></div>
      </div>
      
    </div>

  </div>
</template>

<script>
// import { request } from "@/api/all";
import { mapActions } from "vuex";
var _ = require("lodash");

export default {
  data() {
    return {
      pages: [],
      activeId: null,
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleResponsiveLayoutConfig"]),
    mainMenuOpen() {
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0
        ),
        "ord",
        "asc"
      );
      // request({
      //     api: { method: "POST", url: "TaskCore/GetCoreList" },
      //     data: {
      //         skip: 0,
      //         size: 100,
      //         ot: 356,
      //         model:{
      //             isPublic:true
      //         }
      //     },
      //     store: this.$store
      // }).then(res => {
      //     if(res!=false){
      //         this.pages= _.sortBy(res.data.tasks.filter(x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0), "ord", "asc" );
      //         let _home= res.data.tasks.filter(x=>x.st1=='home');
      //         if(_home.length>0){
      //             this.$emit('load-components', _home[0].id);
      //         }
      //     }
      // });
    },
    getSub(p) {
      let pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == p.id
        ),
        "ord",
        "asc"
      );
      return pages;
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.activeId = null;
    }
  }
};
</script>

<style lang="less">
#subheader{
  box-shadow: 0 0.5rem 0.5rem -0.5rem rgb(0 0 0 / 10%);
  border-bottom: 1px solid #dee2e6 !important;
  
  .navbar-menu{
    margin-top: 0;
    width: auto;
    
    .nav-link{
      font-weight: 700;
      text-transform: uppercase;
    }
  }
}</style>
